import isPointInPolygon from 'point-in-polygon';

export default (objects, coordinates) => {
    const { x, y } = coordinates;

    for (const object of objects) {
        const polygon = object.compiled.polygon.points.map(point => [point.x, point.y]);
        if (isPointInPolygon([x, y], polygon)) {
            return object;
        }
    }

    return null;
};
